import { render, staticRenderFns } from "./SBSAward.vue?vue&type=template&id=1f336167&"
import script from "./SBSAward.vue?vue&type=script&lang=js&"
export * from "./SBSAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports